import React, { useState, useEffect, useMemo } from "react";
import { Accordion, Button, Form, InputGroup } from "react-bootstrap";
import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { getBillingByPatient } from "../../../apis/billing";
import { getSessionByPatientId } from "../../../apis/session";
import { getMembershipCategories } from "../../../apis/membership";
import { getPatientNotes, updateNote } from "../../../apis/notes";
import { getPatientDetailsById } from "../../../apis/patients";
import { toastify } from "../../../helperFunctions/toastify";
import DateInput from "../../SharedComponents/DateInput";
import DeleteModal from "../../SharedComponents/DeleteModal";
import NoteRenderer from "../NoteTaking/NoteRenderer";
import { SearchIcon } from "../../../assets/images/index";
import {
	PDFDownloadLink,
	Document,
	Page,
	View,
	Text,
	StyleSheet,
} from "@react-pdf/renderer";

function GlanceView(props) {
	const [notes, setNotes] = useState([]);

	const [show, setShow] = useState(false);
	const [deleting, setDeleting] = useState("");
	const { state } = props;
	const userData = useSelector((state) => state.userData.value);
	const [date, setDate] = useState({
		start: "",
		end: "",
	});
	const [checkAllDate, setCheckAllDate] = useState(true);
	const [usePointVal, setUsePointVal] = useState(0);
	// const patientData = useSelector((state) => state.patientData.value);
	const [patientData, setPatientData] = useState([]);
	const [filteredData, setFilteredData] = useState([]);
	const [staffSearch, setStaffSearch] = useState("");

	const navigate = useNavigate();

	const getNotesList = async () => {
		const response = await getPatientNotes(state?.id);
		if (response.status !== "Fail") {
			setNotes(response);
		} else if (response?.message === "No data Found") {
			setNotes([]);
		} else {
			toastify(response?.message, "error");
		}
	};

	// let response = await getPatientDetailsById(patientData?._id);
	//   if (response?.status !== "Fail") {
	//     setNotes(
	//       response?.nurseNotesList?.reverse()?.filter((e) => !e.isDeleted)
	//     );
	//   } else {
	//     toastify(response?.message, "error");
	//   }

	useEffect(() => {
		getNotesList();
	}, []);

	const handleClose = () => {
		setShow(false);
		setDeleting("");
	};

	const checkDate = (noteDate) => {
		let day1 = new Date().getDate();
		let day2 = new Date(noteDate).getDate();

		let month1 = new Date().getMonth();
		let month2 = new Date(noteDate).getMonth();

		let year1 = new Date().getFullYear();
		let year2 = new Date(noteDate).getFullYear();

		if (day1 === day2 && month1 === month2 && year1 === year2) return true;
		else return false;
	};

	const removeNote = async () => {
		let isSameDay = false;

		let ind = notes.find((e) => {
			if (deleting === e._id) {
				if (checkDate(e.created_at)) isSameDay = true;
				return e;
			}
		});

		setShow(false);

		if (ind?.staff?._id === userData._id) {
			if (isSameDay) {
				const response = await updateNote(deleting, {
					isDeleted: true,
				});

				if (response?.status !== "Fail") {
					toastify("Note deleted successfully!", "success");
					getNotesList();
				} else {
					toastify(response?.message, "error");
				}
			} else {
				toastify("Note can be deleted on the same day only.", "error");
			}
		} else {
			toastify("Only note maker can update/delete note.", "error");
		}
	};

	useEffect(() => {
		(async () => {
			const { result, error } = await getSessionByPatientId(state?.id);
			if (error) {
				toastify(error.message, "error");
				return;
			}

			const tempArr = result?.data?.map((e) => {
				const historyObj = {
					medicalHistory:
						e.patientMedicalHistory?.pastMedicalHistory,
					cosmeticHistory:
						e.patientMedicalHistory?.pastCosmeticHistory,
					adverseCosmeticHistory:
						e.patientMedicalHistory
							?.pastAdverseCosmeticHistory,
					socialHistory:
						e.patientMedicalHistory?.socialHistory,
				};
				const loc = e?.branch?.location?.find(
					(o) => o._id === e?.location,
				);

				let totalAmount = 0;
				const prescriptionDrugs = e?.patientPrescriptionSheet?.map((o) => {
					totalAmount += o.type === "internal" ? ((o.quantity * o.unitPrice) - o.discount) : 0;

					return {
						name: o.drugName,
						price: o.unitPrice ? o.unitPrice : 0,
						qty: o.quantity,
						discount: o.discount ? o.discount : 0,
						total_price: o.type === "internal" ? ((o.quantity * o.unitPrice) - o.discount) : 0,
						instruction: o.instruction,
						type: o.type
					}
				})

				// const packages = e?.package?.map((o) => {
				// 	return {
				// 		name: o?.package_id?.name,
				// 		qty: o?.package_qty,
				// 		price: o?.package_unit_price * o?.package_qty,
				// 		discount: o?.package_discount,
				// 		total_price: o?.package_price,
				// 	};
				// });
				// const product = e?.product?.map((o) => {
				// 	return {
				// 		name: o?.product_id?.name,
				// 		qty: o?.product_qty,
				// 		price: o?.product_unit_price * o?.product_qty,
				// 		discount: o?.product_discount,
				// 		total_price: o?.product_price,
				// 	};
				// });
				// const treatment = e?.treatment?.map((o) => {
				// 	return {
				// 		name: o?.service_id?.name,
				// 		qty: o?.service_qty,
				// 		price: o?.service_unit_price * o?.service_qty,
				// 		discount: o?.service_discount,
				// 		total_price: o?.service_price,
				// 	};
				// });

				// const others = e?.others?.map((o) => {
				// 	return {
				// 		name: o?.description,
				// 		qty: 1,
				// 		price: o?.total_price,
				// 		discount: 0,
				// 		total_price: o?.total_price,
				// 	};
				// });

				console.log("E", e)

				const taxVal = e.prescriptionGSTAmount;
				const notesObj = {
					startTime: e.startTime,
					endTime: e.endTime,
					staff: e.staff?.map((o) => o?.username),
					soap: e.patientSOAP,
					location: loc,
					// service: [...packages, ...product, ...treatment, ...others],
					service: [...prescriptionDrugs],
					// remarks: e?.remarks,
					// usePoints: e?.usePoints,
					// promo: e?.promo,
					// tax: e?.tax,
					// promoDiscount: (e?.promo / 100) * e?.actualAmount,
					totalAmount: totalAmount,
					afterTaxValue: taxVal,
					// actualAmount: e?.actualAmount,
					// totalAmount: e?.totalAmount,
				};
				return {
					date: new Date(e.created_at).toLocaleDateString(),
					history: historyObj,
					notes: notesObj,
				};
			});
			console.log("galnce view", tempArr)
			setPatientData([...tempArr]);
		})();
		(async () => {
			const res = await getMembershipCategories();
			if (res?.status !== "Fail") {
				setUsePointVal(0);
				return;
			}
			setUsePointVal(res?.point);
		})();
	}, [state?.id]);
	useMemo(() => {
		if (date?.start && date?.end) {
			setCheckAllDate(false);
			let tempArr = [...patientData];
			tempArr = tempArr.filter((e) => {
				if (
					new Date(e?.date) >= date?.start &&
					new Date(e?.date) <= date?.end
				) {
					return true;
				}
			});
			if (tempArr.length === 0) {
				toastify("No result found for applied search", "error");
			}

			setFilteredData([...tempArr]);
		}
	}, [date?.start, date?.end]);
	// const styles = StyleSheet.create({
	// 	page: { backgroundColor: "#fff", padding: 10 },
	// 	border: {
	// 		borderTopWidth: 2,
	// 		borderTopColor: "#0000",
	// 		borderLeftWidth: 2,
	// 		borderLeftColor: "#0000",
	// 		borderRightWidth: 2,
	// 		borderRightColor: "#0000",
	// 		borderBottomWidth: 2,
	// 		borderBottomColor: "#0000",
	// 		marginBottom: 10,
	// 	},
	// 	title: {
	// 		flexDirection: "row",
	// 		justifyContent: "space-between",
	// 		marginBottom: 10,
	// 		borderBottomWidth: 1,
	// 		borderBottomColor: "#e9e9e9",
	// 		paddingBottom: 5,
	// 		paddingLeft: 5,
	// 		paddingRight: 5,
	// 	},
	// 	flex: {
	// 		flexDirection: "row",
	// 	},
	// 	heading: {
	// 		fontSize: 16,
	// 		fontWeight: 900,
	// 		marginRight: 10,
	// 	},
	// 	date: {
	// 		fontSize: 16,
	// 		fontWeight: 900,
	// 	},
	// 	row: {
	// 		flexDirection: "row",
	// 		display: "row",
	// 		justifyContent: "space-between",
	// 		marginTop: 5,
	// 		marginBottom: 5,
	// 		borderBottomWidth: 1,
	// 		borderBottomColor: "#e9e9e9",
	// 		paddingBottom: 5,
	// 		paddingLeft: 5,
	// 		paddingRight: 5,
	// 	},
	// 	tableRow: {
	// 		flexDirection: "row",
	// 		display: "row",
	// 		justifyContent: "space-between",
	// 		marginTop: 5,
	// 		marginBottom: 5,
	// 		backgroundColor: "rgb(233, 233, 233)",
	// 		paddingTop: 5,
	// 		paddingBottom: 5,
	// 		fontWeight: "bolder",
	// 		fontSize: 16,
	// 		paddingLeft: 5,
	// 		paddingRight: 5,
	// 	},
	// 	col5: {
	// 		flex: "0 0 auto",
	// 		width: "41.66666667%",
	// 		fontSize: 14,
	// 		fontWeight: 100,
	// 	},
	// 	col3: {
	// 		flex: "0 0 auto",
	// 		width: "25%",
	// 		fontSize: 14,
	// 		fontWeight: 100,
	// 	},
	// 	col4: {
	// 		flex: "0 0 auto",
	// 		width: "33.33333333%",
	// 		fontSize: 14,
	// 		fontWeight: 100,
	// 	},
	// 	table: {
	// 		display: "table",
	// 		paddingLeft: 5,
	// 		paddingRight: 5,
	// 	},
	// 	marginRight: {
	// 		marginRight: 10,
	// 	},
	// 	marginFont: {
	// 		marginRight: 10,
	// 		fontSize: 14,
	// 		fontWeight: 100,
	// 	},
	// 	tabelHead: {
	// 		marginRight: 10,
	// 		fontSize: 16,
	// 	},
	// 	marginBottom: {
	// 		marginBottom: 5,
	// 	},
	// 	doctorText: {
	// 		marginBottom: 5,
	// 		fontSize: 14,
	// 		fontWeight: 100,
	// 		paddingLeft: 5,
	// 		paddingRight: 5,
	// 	},
	// 	doctorTextBold: {
	// 		marginBottom: 5,
	// 		fontSize: 14,
	// 		borderBottomWidth: 1,
	// 		borderBottomColor: "#e9e9e9",
	// 		backgroundColor: "#e9e9e9",
	// 		paddingBottom: 5,
	// 		paddingTop: 5,
	// 		paddingLeft: 5,
	// 		paddingRight: 5,
	// 	},
	// 	total: {
	// 		width: "40%",
	// 		marginLeft: "auto",
	// 		paddingLeft: 5,
	// 		paddingRight: 5,
	// 	},
	// });
	// const MyDoc = () => (
	// 	<Document>
	// 		<Page
	// 			size="A4"
	// 			style={styles.page}
	// 			render={() => (
	// 				<>
	// 					<View>
	// 						{patientData?.length > 0 &&
	// 							(filteredData?.length > 0
	// 								? filteredData
	// 								: patientData
	// 							)?.map((o) => {
	// 								return (
	// 									<>
	// 										<View style={styles.border}>
	// 											<View style={styles.title}>
	// 												<View style={styles.flex}>
	// 													<Text
	// 														style={
	// 															styles.heading
	// 														}
	// 													>
	// 														Doctor Notes
	// 													</Text>
	// 													<Text
	// 														style={styles.date}
	// 													>
	// 														01/02/23
	// 													</Text>
	// 												</View>
	// 												<View style={styles.flex}>
	// 													<Text
	// 														style={
	// 															styles.heading
	// 														}
	// 													>
	// 														Start: 00:00
	// 													</Text>
	// 													<Text
	// 														style={styles.date}
	// 													>
	// 														Ends: 03:30
	// 													</Text>
	// 												</View>
	// 											</View>
	// 											<View>
	// 												<View>
	// 													<Text
	// 														style={
	// 															styles.doctorText
	// 														}
	// 													>
	// 														Doctor 01
	// 													</Text>
	// 													<Text
	// 														style={
	// 															styles.doctorText
	// 														}
	// 													>
	// 														user2withloc
	// 													</Text>
	// 												</View>
	// 												<View>
	// 													<Text
	// 														style={
	// 															styles.doctorTextBold
	// 														}
	// 													>
	// 														Subjective
	// 													</Text>
	// 													<Text
	// 														style={
	// 															styles.doctorText
	// 														}
	// 													>
	// 														Subjective here this
	// 														is dummy paragrapgh
	// 													</Text>
	// 												</View>
	// 												<View>
	// 													<Text
	// 														style={
	// 															styles.doctorTextBold
	// 														}
	// 													>
	// 														Assesment
	// 													</Text>
	// 													<Text
	// 														style={
	// 															styles.doctorText
	// 														}
	// 													>
	// 														Assesment here this
	// 														is dummy paragrapgh
	// 													</Text>
	// 												</View>
	// 												<View>
	// 													<View
	// 														style={styles.table}
	// 													>
	// 														<View
	// 															style={
	// 																styles.tableRow
	// 															}
	// 														>
	// 															<Text
	// 																style={
	// 																	styles.marginRight
	// 																}
	// 															>
	// 																Service
	// 																Center
	// 															</Text>
	// 															<Text
	// 																style={
	// 																	styles.tabelHead
	// 																}
	// 															>
	// 																Service
	// 															</Text>
	// 															<Text
	// 																style={
	// 																	styles.tabelHead
	// 																}
	// 															>
	// 																Remarks
	// 															</Text>
	// 															<Text
	// 																style={
	// 																	styles.tabelHead
	// 																}
	// 															>
	// 																Quantity
	// 															</Text>
	// 															<Text
	// 																style={
	// 																	styles.tabelHead
	// 																}
	// 															>
	// 																Subtotal
	// 															</Text>
	// 															<Text
	// 																style={
	// 																	styles.tabelHead
	// 																}
	// 															>
	// 																Discount
	// 															</Text>
	// 															<Text
	// 																style={
	// 																	styles.tabelHead
	// 																}
	// 															>
	// 																Total
	// 															</Text>
	// 														</View>
	// 														<View
	// 															style={
	// 																styles.row
	// 															}
	// 														>
	// 															<Text
	// 																style={
	// 																	styles.marginFont
	// 																}
	// 															>
	// 																abc location
	// 															</Text>
	// 															<Text
	// 																style={
	// 																	styles.marginFont
	// 																}
	// 															>
	// 																Selsum Blue
	// 															</Text>
	// 															<Text
	// 																style={
	// 																	styles.marginFont
	// 																}
	// 															>
	// 																Good
	// 															</Text>
	// 															<Text
	// 																style={
	// 																	styles.marginFont
	// 																}
	// 															>
	// 																1
	// 															</Text>
	// 															<Text
	// 																style={
	// 																	styles.marginFont
	// 																}
	// 															>
	// 																$200
	// 															</Text>
	// 															<Text
	// 																style={
	// 																	styles.marginFont
	// 																}
	// 															>
	// 																0
	// 															</Text>
	// 															<Text
	// 																style={
	// 																	styles.marginFont
	// 																}
	// 															>
	// 																$200
	// 															</Text>
	// 														</View>
	// 													</View>
	// 													<View
	// 														style={styles.total}
	// 													>
	// 														<View
	// 															style={
	// 																styles.row
	// 															}
	// 														>
	// 															<Text
	// 																style={
	// 																	styles.col5
	// 																}
	// 															>
	// 																Sub Total:
	// 															</Text>
	// 															<Text
	// 																style={
	// 																	styles.col3
	// 																}
	// 															></Text>
	// 															<Text
	// 																style={
	// 																	styles.col4
	// 																}
	// 															>
	// 																$200
	// 															</Text>
	// 														</View>
	// 														<View
	// 															style={
	// 																styles.row
	// 															}
	// 														>
	// 															<Text
	// 																style={
	// 																	styles.col5
	// 																}
	// 															>
	// 																Promo
	// 															</Text>
	// 															<Text
	// 																style={
	// 																	styles.col3
	// 																}
	// 															>
	// 																0%
	// 															</Text>
	// 															<Text
	// 																style={
	// 																	styles.col4
	// 																}
	// 															>
	// 																$0
	// 															</Text>
	// 														</View>
	// 														<View
	// 															style={
	// 																styles.row
	// 															}
	// 														>
	// 															<Text
	// 																style={
	// 																	styles.col5
	// 																}
	// 															>
	// 																Points
	// 															</Text>
	// 															<Text
	// 																style={
	// 																	styles.col3
	// 																}
	// 															>
	// 																0
	// 															</Text>
	// 															<Text
	// 																style={
	// 																	styles.col4
	// 																}
	// 															>
	// 																$0
	// 															</Text>
	// 														</View>
	// 														<View
	// 															style={
	// 																styles.row
	// 															}
	// 														>
	// 															<Text
	// 																style={
	// 																	styles.col5
	// 																}
	// 															>
	// 																Total:
	// 															</Text>
	// 															<Text
	// 																style={
	// 																	styles.col3
	// 																}
	// 															></Text>
	// 															<Text
	// 																style={
	// 																	styles.col4
	// 																}
	// 															>
	// 																$200
	// 															</Text>
	// 														</View>
	// 													</View>
	// 												</View>
	// 											</View>
	// 										</View>
	// 									</>
	// 								);
	// 							})}
	// 					</View>
	// 				</>
	// 			)}
	// 		>
	// 			<View style={styles.section}></View>
	// 		</Page>
	// 	</Document>
	// );
	return (
		<div>
			<div className="d-flex">
				<div className=" col-md-4 me-4  grey-bg ">
					<div className="bold patient-history white-background mt-0 py-2">
						Patient History
					</div>
					<div className="mb-3 white-background ">
						<div className="history mt-0 py-2">Medical History</div>

						{patientData?.length > 0 &&
							(filteredData?.length > 0
								? filteredData
								: patientData
							)?.map((e, i) => {
								if (!e.history?.medicalHistory) {
									return <></>;
								}
								return (
									<>
										<Accordion>
											<Accordion.Item
												eventKey="0"
												style={{
													border: "none",
													outline: "none",
												}}
											>
												<Accordion.Header>
													<div className="bold font-14">
														{e.date}
													</div>
												</Accordion.Header>
												<Accordion.Body>
													<div>
														<div>
															<div>
																{
																	e.history
																		?.medicalHistory
																}
															</div>
														</div>
													</div>
												</Accordion.Body>
											</Accordion.Item>
										</Accordion>
									</>
								);
							})}
					</div>
					<div className="mb-3 white-background">
						<div className="history py-2">Cosmetic History</div>

						{patientData?.length > 0 &&
							(filteredData?.length > 0
								? filteredData
								: patientData
							)?.map((e, i) => {
								if (!e.history?.cosmeticHistory) {
									return <></>;
								}
								return (
									<>
										<Accordion>
											<Accordion.Item
												eventKey="0"
												style={{
													border: "none",
													outline: "none",
												}}
											>
												<Accordion.Header>
													<div className="bold font-14">
														{e.date}
													</div>
												</Accordion.Header>
												<Accordion.Body>
													<div>
														<div>
															<div>
																{
																	e.history
																		?.cosmeticHistory
																}
															</div>
														</div>
													</div>
												</Accordion.Body>
											</Accordion.Item>
										</Accordion>
									</>
								);
							})}
					</div>
					<div className="mb-3 white-background">
						<div className="history py-2">
							Adverse Cosmetic History
						</div>

						{patientData?.length > 0 &&
							(filteredData?.length > 0
								? filteredData
								: patientData
							)?.map((e, i) => {
								if (!e.history?.adverseCosmeticHistory) {
									return <></>;
								}
								return (
									<>
										<Accordion>
											<Accordion.Item
												eventKey="0"
												style={{
													border: "none",
													outline: "none",
												}}
											>
												<Accordion.Header>
													<div className="bold font-14">
														{e.date}
													</div>
												</Accordion.Header>
												<Accordion.Body>
													<div>
														<div>
															<div>
																{
																	e.history
																		?.adverseCosmeticHistory
																}
															</div>
														</div>
													</div>
												</Accordion.Body>
											</Accordion.Item>
										</Accordion>
									</>
								);
							})}
					</div>
					<div className="mb-3 white-background">
						<div className="history py-2">Social History</div>

						{patientData?.length > 0 &&
							(filteredData?.length > 0
								? filteredData
								: patientData
							)?.map((e, i) => {
								if (!e.history?.socialHistory) {
									return <></>;
								}
								return (
									<>
										<Accordion>
											<Accordion.Item
												eventKey="0"
												style={{
													border: "none",
													outline: "none",
												}}
											>
												<Accordion.Header>
													<div className="bold font-14">
														{e.date}
													</div>
												</Accordion.Header>
												<Accordion.Body>
													<div>
														<div>
															<div>
																{
																	e.history
																		?.socialHistory
																}
															</div>
														</div>
													</div>
												</Accordion.Body>
											</Accordion.Item>
										</Accordion>
									</>
								);
							})}
					</div>
				</div>
				<div className="white-background p-3 px-0 w-100">
					<div className="date-container d-flex" style={{alignItems: "center"}}>
						<div
							className="d-flex"
							style={{
								width: "calc(100% - 130px)",
								minWidth: "330px",
							}}
						>
							<DateInput
								label={"Visit Date:"}
								value={date.start}
								placeholder="Start Date"
								onChange={(e) => {
									setDate((val) => {
										return { ...val, start: e };
									});
								}}
							/>

							<DateInput
								label={"To:"}
								placeholder="End Date"
								className="ms-2"
								value={date.end}
								onChange={(e) => {
									if (!date?.start) {
										toastify(
											"Please select start date",
											"error",
										);
										return;
									}
									if (e < date?.start) {
										toastify(
											"End date can't be less than start date",
											"error",
										);
										return;
									}
									setDate((val) => {
										return { ...val, end: e };
									});
								}}
							/>
						</div>
						{/* <PDFDownloadLink
							document={<MyDoc />}
							fileName="somename.pdf"
						>
							{({ blob, url, loading, error }) => {
								return loading
									? "Loading document..."
									: "Download now!";
							}}
						</PDFDownloadLink> */}
						{/* <div
							className="align-self-end ms-2"
							style={{ marginBottom: "13px" }}
						>
							<Form.Check
								type={"checkbox"}
								label={"All Date"}
								size={"lg"}
								checked={checkAllDate}
								onChange={() => {
									if (!checkAllDate) {
										setFilteredData([...patientData]);
									}
									setCheckAllDate(!checkAllDate);
								}}
							/>
						</div> */}
						<Button
							className="addItem ms-2"
							onClick={() => {}}
							style={{ height: "45px", width: "130px", marginTop: "20px" }}
						>
							Search
						</Button>
					</div>
					{/* <div className="d-flex mb-3">
						<Form.Group
							className="position-relative"
							style={{
								width: "calc(50% - 67px)",
								minWidth: "175px",
							}}
						>
							<InputGroup
								className="p-0 search-group"
								style={{ borderRadius: "8px" }}
							>
								<Form.Control
									placeholder="All Selected"
									value={staffSearch}
									onChange={(e) => {
										if (e.target.value) {
											let tempArr = patientData?.filter(
												(o) => {
													if (
														o?.notes?.staff?.find(
															(k) =>
																k
																	.toLowerCase()
																	.includes(
																		e.target.value.toLowerCase(),
																	),
														)
													) {
														return true;
													}
												},
											);
											setFilteredData([...tempArr]);
										}
										setStaffSearch(e.target.value);
									}}
								/>
								<Button style={{ borderRadius: 0 }}>
									<img src={SearchIcon} />
								</Button>
							</InputGroup>
						</Form.Group>
					</div> */}
					{patientData?.length > 0 &&
						(filteredData?.length > 0 ? filteredData : patientData)
							?.reverse()
							?.map((o) => {
								return (
									<>
										<div className="mb-3">
											<NoteRenderer
												role={"Doctor"}
												notes_data={o.notes}
												date={o.date}
												pointVal={usePointVal}
											/>
										</div>
									</>
								);
							})}

					{notes?.map((e) => (
						<NoteRenderer
							note={e}
							role={"Nurse"}
							handleClose={handleClose}
							show={show}
							setShow={setShow}
							setDeleting={setDeleting}
							// editNote={editNote}
						/>
					))}
					<DeleteModal
						content="Confirm Patient Note Deletion?"
						onYes={removeNote}
						onNo={handleClose}
						show={show}
					/>
				</div>
			</div>
		</div>
	);
}

export default GlanceView;
